// CENTRALIZED FEATURE TOGGLE CONTROL
// Set to true to enable both promotional banner and promos section  
// Set to false to disable both promotional banner and promos section
export const PROMO_FEATURES_ENABLED = false;

// Set to true to enable testimonials section
// Set to false to disable testimonials section (for data compliance)
export const TESTIMONIALS_ENABLED = false;

// These switches control:
// PROMO_FEATURES_ENABLED:
// 1. Promotional banner (scrolling bar at top)
// 2. Promos section (between Testimonials and Contact)
// 3. Promo menu item visibility
// 4. Menu bar positioning (adjusts when banner is disabled)
//
// TESTIMONIALS_ENABLED:
// 1. Testimonials section visibility
// 2. Testimonials menu item visibility
